import { type FormEvent, useEffect, useState } from "react";
import { Button, Input, Modal } from "@/components/common";
import type { AgentCommission } from "@/types/commission";

interface EditCommissionModalProps {
  agent: AgentCommission | null;
  onClose: () => void;
  onSave: (agentId: string, commissionRate: number) => void;
  isLoading?: boolean;
}

export function EditCommissionModal({
  agent,
  onClose,
  onSave,
  isLoading = false,
}: EditCommissionModalProps) {
  const [rate, setRate] = useState("");

  useEffect(() => {
    if (agent) {
      setRate(String(agent.commissionRate));
    }
  }, [agent]);

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (!agent) {
      return;
    }
    const parsed = Number.parseFloat(rate);
    if (Number.isNaN(parsed) || parsed < 0 || parsed > 100) {
      return;
    }
    onSave(agent.agentId, parsed);
  }

  return (
    <Modal isOpen={agent !== null} onClose={onClose} title="Ustaw prowizję">
      {agent && (
        <form onSubmit={handleSubmit} className="space-y-4">
          <p className="text-sm text-sub">
            Agent:{" "}
            <span className="font-medium text-main">
              {agent.firstName} {agent.lastName}
            </span>
          </p>

          <Input
            label="Stawka prowizji"
            type="number"
            min={0}
            max={100}
            step={0.1}
            value={rate}
            onChange={(e) => {
              setRate(e.target.value);
            }}
            rightElement={<span className="pr-2 text-sm text-faint">%</span>}
          />

          <div className="flex justify-end gap-3 pt-2">
            <Button variant="outline" type="button" onClick={onClose}>
              Anuluj
            </Button>
            <Button type="submit" isLoading={isLoading}>
              Zapisz
            </Button>
          </div>
        </form>
      )}
    </Modal>
  );
}
